export default {
  application: {
    deployment: 'Deployment',
    document: 'Docs',
    'en-US': 'English',
    github: 'GitHub',
    productTitle: 'Online Form Designer',
    qqGroup: 'WeChat Group',
    subscription: 'Subscription',
    'zh-CN': '简体中文',
  },

  designer: {
    advancedFieldTitle: 'Advanced Field',
    basicFieldTitle: 'Basic Field',
    componentLib: 'Components',
    containerTitle: 'Container',
    customFieldTitle: 'Customized Field',
    dragAction: 'drag',
    dragHandlerHint: 'drag container or field to layout center',
    formLib: 'Templates',

    hint: {
      cancel: 'Cancel',
      cellSetting: 'Cell setting',
      chineseValidator: 'Chinese',
      cloneWidget: 'Clone this widget',
      closePreview: 'Close',
      colspanNotConsistentForDeleteEntireColumn: "Cells in this column don't have the same colspan, operation failed.",
      colspanNotConsistentForMergeEntireColumn: "Cells in this column don't have the same colspan, operation failed.",
      confirm: 'OK',
      copyField: 'Copy field widget',
      copyFormData: 'Copy',
      copyHtmlCode: 'Copy HTML Code',
      copyHtmlCodeFail: 'Copy failed',
      copyHtmlCodeSuccess: 'Copy succeed',
      copyJson: 'Copy',

      copyJsonFail: 'Copy failed',
      copyJsonSuccess: 'Copy succeed',
      copySFCFail: 'Copy failed',
      copySFCSuccess: 'Copy succeed',
      copyVue2SFC: 'Copy Vue2',
      copyVue3SFC: 'Copy Vue3',
      copyVueCode: 'Copy Vue Code',
      copyVueCodeFail: 'Copy failed',
      copyVueCodeSuccess: 'Copy succeed',
      currentNodeCannotBeSelected: 'The current node cannot be selected.',
      disableForm: 'Disable',
      dragHandler: 'Drag handler',
      duplicateName: 'Duplicate name: ',
      emailValidator: 'Email',
      enableForm: 'Enable',
      exportFormData: 'Form Data',
      fileNameForSave: 'File name:',
      fileNameInputPlaceholder: 'Enter the file name',
      formSetting: 'Form Prop',
      getFormData: 'Get Data',

      import: 'Import',
      importDSHint: 'The format of the imported datasource must be valid.',
      importJsonHint: 'The code to be imported should have the following JSON format.',
      importJsonSuccess: 'Import succeed',
      insertColumn: 'Insert new column',
      insertRow: 'Insert new row',
      invalidJsonFormat: 'Invalid JSON format',
      invalidOptionsData: 'Invalid data of options:',
      jsonVersionMismatch: 'Version of JSON mismatch',
      lastColCannotBeDeleted: 'The last col cannot be deleted.',
      lastPaneCannotBeDeleted: 'The last pane cannot be deleted.',
      lastRowCannotBeDeleted: 'The last row cannot be deleted.',
      letterAndNumberValidator: 'LetterAndNumber',
      letterValidator: 'Letter',
      loadFormTemplate: 'Load This',
      loadFormTemplateFailed: 'Load form template failed.',
      loadFormTemplateHint: 'Are you sure to load this template?',
      loadFormTemplateSuccess: 'Load form template success!',
      maxTextLengthError: 'Length must be less than {maxLength}.',
      minTextLengthError: 'Length must be greater than {minLength}.',
      mobilePhoneValidator: 'MobilePhone',

      moveDownLastChildHint: 'Last child can not be move down',
      moveDownWidget: 'Move down this widget',
      moveUpFirstChildHint: 'First child can not be move up',
      moveUpWidget: 'Move up this widget',

      nameRequired: 'Name required.',
      noChineseValidator: 'Non-Chinese',
      noSelectedWidgetHint: 'No selected widget.',
      numberValidator: 'Number',
      onlyFieldWidgetAcceptable: 'Only field widget can be dragged into sub-form',
      prompt: 'Prompt',
      remove: 'Remove this widget',
      resetForm: 'Reset',
      rowspanNotConsistentForDeleteEntireRow: "Cells in this row don't have the same rowspan, operation failed.",
      rowspanNotConsistentForMergeEntireRow: "Cells in this row don't have the same rowspan, operation failed.",

      sampleLoadedFail: 'Sample load failed',
      sampleLoadedSuccess: 'Example loaded successfully',
      saveFileTitle: 'Save as File',
      saveFormData: 'Save As File',
      saveFormJson: 'Save As File',
      saveHtmlCode: 'Save Html File',
      saveVue2SFC: 'Save As Vue2',
      saveVue3SFC: 'Save As Vue3',

      saveVueCode: 'Save Vue File',
      searchPlaceholder: 'Please Input Search Words',
      selectParentWidget: 'Select parent of this widget',
      switchReadMode: 'Read Mode',
      urlValidator: 'URL',
      widgetSetting: 'Widget Prop',
    },

    noWidgetHint: 'Please select a widget from the left list, drag and drop to this container.',

    setting: {
      // actionColumn: 'Action',
      // addOperationButton: 'Add New Button',
      // addTableColumn: 'Add New Column',
      // alignTypeOfColumn: 'Align',
      // buttonsColumnEdit: 'Edit Buttons',
      // buttonsColumnTitle: 'Title',
      // buttonsColumnWidth: 'Width(px)',
      // columnLabel: 'Label',
      // columnName: 'Name',
      // columnWidth: 'Width(px/%)',
      // customRenderGroup: 'Custom Render',
      // data-source
      // data-table
      // deleteOperationButtonHint: 'Delete this button?',
      // deleteTableColumn: 'Delete This Column',
      // editAction: 'Edit...',
      // fixedColumn: 'Fixed',
      // formatOfColumn: 'Format',
      // onlyOneColumnCannotBeDeleted: 'The last column cannot be deleted.',
      // operationButtonDisabled: 'Disabled',
      // operationButtonDuplicatedNameError: 'Duplicate button name.',
      // operationButtonHidden: 'Hidden',
      // operationButtonLabel: 'Text',
      // operationButtonName: 'Name',
      // operationButtonRound: 'Round',
      // operationButtonSize: 'Size',
      // operationButtonsSetting: 'Buttons Setting',
      // operationButtonType: 'Type',
      // renderFunction: 'Render',
      // rowSpacing: 'Row Spacing(px)',
      // showButtonsColumn: 'Buttons Column',
      // showCheckBox: 'Show CheckBox',
      // showIndex: 'Show Row Number',
      // showPagination: 'Show Pagination',
      // showSummary: 'Show Summary',
      // smallPagination: 'Small Pagination',
      // sortableColumn: 'Sortable',
      // stripe: 'Stripe',
      // tableColEdit: 'Edit Cols',
      // tableDataEdit: 'Edit Data',
      // tableHeight: 'Height(px/%)',
      // tableWidth: 'Width(px/%)',
      // visibleColumn: 'Visible',
      activeColor: 'Active Color',
      activeText: 'Active Text',
      activeValue: 'Active Value',
      addColumn: 'Add Column',
      addCss: 'Edit',
      addDataSet: 'Add Dataset',
      addDataSource: 'Add Datasource',
      addEventHandler: 'Edit',
      addOption: 'Add Option',
      addRequestData: 'Add Data',
      addRequestHeader: 'Add Header',
      addRequestParam: 'Add Param',
      addTabPane: 'Add Tab Pane',
      advancedSetting: 'Advanced Setting',
      allowCreate: 'Allow Create',
      allowHalf: 'Allow Half',
      appendButton: 'Append Button',
      appendButtonDisabled: 'Button Disabled',
      appendButtonIcon: 'Button Icon',
      appendButtonLabel: 'Button Label',
      appendButtonType: 'Button Type',
      attributeSetting: 'Attribute Setting',
      automaticDropdown: 'Automatic Dropdown',
      basicSetting: 'Basic Setting',
      blockLayout: 'block',
      border: 'Show Border',
      buttonIcon: 'Button Icon',
      buttonStyle: 'Show As Button',
      cellHeight: 'Height',
      cellWidth: 'Width',
      centerAlign: 'Center',
      checkStrictly: 'Any Level Selectable',
      childrenKeyName: 'Children Key',
      circle: 'Circle',
      clearExistingDataSource: 'Empty the existing datasource',
      clearRequestResult: 'Clear Result',
      clearable: 'Clearable',
      closeButtonDefaultText: 'confirm',
      closeButtonText: 'close button text',
      colOffsetTitle: 'Offset Of Col',
      colPullTitle: 'Pull Of Col',
      colPushTitle: 'Push Of Col',
      colSpanTitle: 'Spans Of Col',
      colorStyle: 'Color Style',
      colsOfGrid: 'Cols Of Grid:',
      columnSetting: 'Cols Setting',
      commonSetting: 'Common Setting',
      contentPosition: 'Content Position',
      controlsPosition: 'Controls Position',
      customClass: 'Custom Class',
      customLabelIcon: 'Custom Label',
      dashed: 'Dashed',
      dataSetEnabled: 'Multiple Datasets Enabled',
      dataSetName: 'Dataset Name',
      dataSetRemarkInputPlaceholder: 'Remark',
      dataSetSetting: 'List Of Datasets',
      dataSetSettingTitle: '4. Dataset Setting',
      dataSource: 'Datasource',
      dataSourceChecked: 'Checked',
      dataSourceSetting: 'Datasource Setting',
      defaultAlign: 'Default',
      defaultValue: 'Default Value',
      deleteDataSourceHint: 'Delete this datasource？',
      deleteEntireCol: 'delete entire column',
      deleteEntireRow: 'delete entire row',
      disabled: 'Disabled',
      displayDirection: 'Direction',
      displayStyle: 'Display Style',
      displayType: 'Type',
      displayType: 'Tab Type',
      dsConfigHandlerTitle: '1. Config Handler',
      dsDataHandlerTitle: '2. Data Handler',
      dsDescription: 'Description',
      dsDuplicatedNameError: 'Duplicate datasource name.',
      dsEnabled: 'Use Datasource',
      dsErrorHandlerTitle: '3. Error Handler',
      dsName: 'Datasource Name',
      dsRequestBooleanTypeError: 'Boolean value error',
      dsRequestData: 'Data',
      dsRequestHeaders: 'Headers',
      dsRequestMethod: 'Request Method',
      dsRequestNameInputPlaceholder: 'Name',
      dsRequestNumberTypeError: 'Number value error',
      dsRequestParams: 'Params',
      dsRequestResult: 'Result Data',
      dsRequestTypeInputPlaceholder: 'Type',
      dsRequestURL: 'Request URL',
      dsRequestURLType: 'Request URL Type',
      dsRequestValueBooleanType: 'Boolean',
      dsRequestValueInputPlaceholder: 'Value',
      dsRequestValueNumberType: 'Number',
      dsRequestValueStringType: 'String',
      dsRequestValueVariableType: 'Variable',
      dsURLStringType: 'String',
      dsURLVariableType: 'Expression',
      dsUniqueName: 'Unique Name',
      dsValidationError: 'Datasource check failure.',
      dsvTitle: 'Datasource Variable',
      editFormEventHandler: 'Edit Form Event Handler',
      editNameHelp: 'Press enter to confirm the modification',
      editWidgetEventHandler: 'Edit Widget Event Handler',
      editable: 'Editable',
      endPlaceholder: 'End Placeholder',
      eventSetting: 'Event Setting',
      executeDataSource: 'Run Test',
      exportDataSource: 'Export Datasource',
      fieldValueRequired: 'Value can not be null',
      fileMaxSize: 'Max Size(MB)',
      fileTypes: 'Upload File Types',
      fileTypesHelp: 'Allows to add more file types',
      filterable: 'Filterable',
      fontSize: 'Font Size',
      formBackground: 'Form Background',
      formCss: 'Form CSS',
      formModelName: 'Model Name',
      formPadding: 'Form Padding',
      formRadius: 'Form Radius',
      formRefName: 'Ref Name',
      formRulesName: 'Rules Name',
      formSFCSetting: 'SFC Setting',
      formSize: 'Size',
      format: 'Format',
      globalFunctions: 'Global Functions',
      gridColHeight: 'Height Of Col(px)',
      gutter: 'Gutter(px)',
      headers: 'Request Headers',
      hidden: 'Hidden',
      hiddenHelp: 'Hidden read-only fields without a default value will fail upon validation.',
      highThreshold: 'High Threshold',
      horizontalDirection: 'Horizontal',
      htmlContent: 'HTML',
      icon: 'Icon',
      iconSize: 'Icon Size(px)',
      importDataSource: 'Import Datasource',
      importOptions: 'Import Options',
      inactiveColor: 'Inactive Color',
      inactiveText: 'Inactive Text',
      inactiveValue: 'Inactive Value',
      inlineLayout: 'inline',
      inputAlign: 'Input Align',
      inputBorder: 'Input Area Border',
      inputButton: 'Input Button Setting',
      insertColumnToLeft: 'insert column to left',
      insertColumnToRight: 'insert column to right',
      insertRowAbove: 'insert row above',
      insertRowBelow: 'insert row below',
      inset: 'Card Style',
      label: 'Label',
      labelAlign: 'Label Align',
      labelHidden: 'Hide Label',
      labelIconClass: 'Label Icon Class',
      labelIconPosition: 'Label Icon Position',
      labelKeyName: 'Label Key',
      labelPosition: 'Position Of Label',
      labelTooltip: 'Label Tooltip',
      labelWidth: 'Width Of Label',
      leftAlign: 'Left',
      leftIcon: 'Left Icon',
      leftPosition: 'Left',
      limit: 'Max Upload Number',
      lowThreshold: 'Low Threshold',
      maxDate: 'Max Date',
      maxLength: 'Max Length',
      maxStars: 'Stars Max Number',
      maxValue: 'Max Value',
      mergeEntireColumn: 'merge entire column',
      mergeEntireRow: 'merge entire row',
      mergeLeftColumn: 'merge left cell',
      mergeRightColumn: 'merge right cell',
      mergeRowAbove: 'merge cell above',
      mergeRowBelow: 'merge cell below',
      minDate: 'Min Date',
      minLength: 'Min Length',
      minValue: 'Min Value',
      multiple: 'Multiple',
      multipleLimit: 'Multiple Limit',
      multipleSelect: 'File Multi-select',
      noDataSource: 'No datasource.',
      optionsSetting: 'Options Setting',
      paneActive: 'Active',
      placeholder: 'Placeholder',
      plain: 'Plain',
      popupZIndex: 'Popup Z-Index',
      precision: 'Precision',
      previewDataSourceExportResult: 'Preview Result',
      range: 'Range',
      readonly: 'Readonly',
      remainExistingDataSource: 'Append to the existing datasource',
      remote: 'Remote Query',
      required: 'Required',
      requiredHint: 'Failure Hint',
      resetDefault: 'Reset Default',
      responsive: 'Responsive',
      rightAlign: 'Right',
      rightIcon: 'Right Icon',
      round: 'Round',
      rows: 'Rows',
      saveDataSource: 'Save Datasource',
      selectDataSourceForExport: 'Select Datasource',
      showBlankRow: 'Show Blank Row',
      showFileList: 'Show File List',
      showPassword: 'Show Reveal',
      showRowNumber: 'Show Row Number',
      showScore: 'Show Score',
      showStops: 'Show Stops',
      showText: 'Show Text',
      showWordLimit: 'Show Word Limit',
      startPlaceholder: 'Start Placeholder',
      step: 'Step',
      stepButtonSize: 'Button Size(px)',
      switchSize: 'Size(px)',
      syntaxCheckWarning: 'Syntax error in the javascript codes, please check again!',
      tabPaneSetting: 'Tab Panes',
      testDataSource: 'Test Datasource',
      textContent: 'Text',
      textEllipsis: 'Ellipsis Text',
      topPosition: 'Top',
      undoMergeCol: 'undo merge column',
      undoMergeRow: 'undo merge row',
      uniqueName: 'Unique Name',
      uploadButtonText: 'Text Of Button',
      uploadPictureCapture: 'Select Capture Type',
      uploadPictureCaptureAlbum: 'Select From Album',
      uploadPictureCaptureAlbumTip: 'Select From Album Only Support Uniapp Render (WeChat & App)',
      uploadPictureCaptureAll: 'All',
      uploadPictureCaptureCamera: 'Take Picture',
      uploadSetting: 'Upload Setting',
      uploadTip: 'Tip Content',
      uploadURL: 'Upload URL',
      validation: 'Validation',
      validationHelp: 'Regular expressions supported',
      validationHint: 'Validation Hint',
      valueFormat: 'Value Format',
      valueKeyName: 'Value Key',
      vertical: 'Vertical',
      verticalDirection: 'Vertical',
      widgetColumnWidth: 'Width',
      widgetName: 'Unique Name',
      widgetSize: 'Size',
      withCredentials: 'Send Cookie',
    },

    toolbar: {
      clear: 'Clear',
      exportCode: 'Codes',
      exportJson: 'Export',
      generateCode: 'Generate Code',
      generateSFC: 'Generate SFC',
      importJson: 'Import',
      mobileLayout: 'H5',
      nodeTreeHint: 'Tree View Of Component Hierarchy',
      nodeTreeTitle: 'Tree View Of Component Hierarchy',
      padLayout: 'Pad',
      pcLayout: 'PC',
      preview: 'Preview',
      redoHint: 'Redo',
      undoHint: 'Undo',
    },

    widgetLabel: {
      color: 'ColorPicker',
      custom: 'Custom Component',
      'm-button': 'Button',
      'm-calendar': 'Calendar',
      'm-cascader': 'Cascader',
      'm-cell-group': 'Group',
      'm-checkbox': 'Checkbox',
      'm-date': 'Date',

      'm-date-range': 'Date range',
      'm-datetime': 'Datetime',
      'm-divider': 'Divider',
      'm-file-upload': 'File',
      'm-grid': 'Grid',
      'm-grid-col': 'GridCol',
      'm-html-text': 'HTML',
      // 'data-table':     'DataTable',
      'm-input': 'Input',
      'm-number': 'Number',
      'm-password': 'Password',
      'm-picture-upload': 'Picture',
      'm-radio': 'Radio',
      'm-rate': 'Rate',
      'm-select': 'Picker',
      'm-slider': 'Slider',
      'm-slot': 'Slot',
      'm-static-text': 'Text',
      'm-stepper': 'Stepper',
      'm-sub-form': 'SubForm',
      'm-switch': 'Switch',
      // table:            'Table',
      'm-tab': 'Tab',
      'm-textarea': 'Textarea',

      'm-time': 'Time',
      'rich-editor': 'Rich Editor',
      // section:          'Section',
      'sub-form': 'SubForm',
      'tab-pane': 'TabPane',
      'table-cell': 'TableCell',

      'time-range': 'Time range',
    },
  },
};
